import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { ReactElement } from "react";
import {
	KnowledgeItemNotificationDataViewModel,
	KnowledgeItemReactionNotificationDataViewModel
} from "client/Api/Notifications/notifications";
import { HubDetailsDialog } from "client/Features/Hub/HubDetailsDialog";

export type KnowledgeItemActivityInvocationProps = {
	data: KnowledgeItemNotificationDataViewModel | KnowledgeItemReactionNotificationDataViewModel;
	onDismiss: () => void;
};

export const KnowledgeItemActivityInvocation = (props: KnowledgeItemActivityInvocationProps): ReactElement => {
	const {
		data,
		onDismiss
	} = props;

	const {
		knowledgeItemId
	} = data;

	return (
		<HubDetailsDialog
			itemKind={HubItemKind.KnowledgeItem}
			id={knowledgeItemId}
			onClose={onDismiss}
		/>
	);
};

KnowledgeItemActivityInvocation.displayName = "KnowledgeItemActivityInvocation";